import { TApplicationState } from '../../types/redux';

export function getAerialViewLink(state: TApplicationState): string | null {
  const { newbuilding } = state;

  return (newbuilding.panorama && newbuilding.panorama.url) || null;
}
